<template>
  <div class="personAce page-padding">
    <router-view></router-view>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
.personAce {
  width: 100%;
  height: 100%;
}
</style>